<div class="mc-spring-board">
  <mat-toolbar class="mc-spring-board-header mc-review-edit-snippet-dialog-toolbar" color="secondary">
    <ng-container *ngIf="review$ | async as review">
      <mc-project-avatar [project]="review.file.ProjectId | mcProjectAsync : true | async" [truncate]="true" size="small"></mc-project-avatar>
      <mat-divider class="mc-toolbar-divider" vertical="true"></mat-divider>
      <mc-review-package-avatar [reviewPackage]="review.file.ReviewPackageId | mcReviewPackageAsync: true | async" size="small" [truncate]="true"></mc-review-package-avatar>
      <mat-divider class="mc-toolbar-divider" vertical="true"></mat-divider>
      <mc-review-file-avatar color="default" [reviewFile]="review.file" size="small" [truncate]="true"></mc-review-file-avatar>
    </ng-container>

    <span class="mc-fill-remaining-flex-space"></span>

    <ng-container *ngIf="review$ | async as review">
      <mc-flare-file-reviewer-toolbar-content class="mc-review-edit-snippet-dialog-file-reviewer-toolbar mc-toolbar-item-full" [flareTextEditor]="flareFileReviewer?.flareTextEditor" [reviewFile]="review.file" [reviewFileUser]="(review$ | async)?.user" (reviewerStatusUpdate)="onReviewerStatusUpdated($event)"></mc-flare-file-reviewer-toolbar-content>
    </ng-container>

    <span class="mc-toolbar-spacer-small"></span>

    <button mat-icon-button color="secondary-invert" type="button" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </mat-toolbar>

  <div class="mc-spring-board-form-body mc-review-edit-snippet-dialog-spring-board-body">
    <ng-container *ngIf="review$ | async as review">
      <mc-flare-file-reviewer *ngIf="!review.file.IsDeleted" class="mc-review-edit-snippet-dialog-editor" [reviewPackageId]="data.reviewPackageId" [reviewFile]="review.file" [featureSetVersion]="data.featureSetVersion" [reviewFileUser]="review.user" [reviewer]="data.reviewer" [showConditions]="data.showConditions" [stylesEnabled]="data.stylesEnabled" (reviewerStatusUpdate)="onReviewerStatusUpdated($event)" (navToFile)="onNavToFile($event)" (showConditionsChange)="onShowConditionsChanged($event)" (stylesEnabledChange)="onStylesEnabledChanged($event)" (load)="onCollabDocLoaded($event)" (stylesheetLoad)="onCollabDocStylesheetLoad()" (stylesheetLoaded)="onCollabDocStylesheetLoaded($event)"></mc-flare-file-reviewer>
    </ng-container>

    <mc-loader *ngIf="loadingState.loading$ | async"></mc-loader>

    <div *ngIf="loadingState.generalError$ | async as generalError" class="error-pane">
      <mc-errors-expansion-panel [generalError]="generalError" [detailedErrors]="loadingState.detailedErrors$ | async" (retry)="onRetryLoadFile()"></mc-errors-expansion-panel>
    </div>
  </div>
</div>